import React, { PropsWithChildren } from "react";

export default (props: PropsWithChildren<{}>) => (
  <span style={{ color: "red" }}>{props.children}</span>
);
